<sigecom-content-container [title]="'Gerenciamento de rodadas e confrontos'">
  <div buttons>
    <sigecom-button type="info" outlined title="VER TABELA DE JOGOS" icon="table"
      (buttonClicked)="openGamesTable()"></sigecom-button>
  </div>
  <div before-content>
    <div class="flex-col flex gap-4 pt-2">
      <div class="grid grid-cols-2 gap-4">
        <sigecom-new-dropdown required="true" label="Evento" class="bg-white rounded-lg"
          [options]="events?.content || []" [optionLabel]="'eveTxNome'" [optionIdentify]="'eveNrId'"
          [lastValidSelectedOption]="selectedEvent || null" [searchble]="true" (searchChange)="onEventSearch($event)"
          placeholder="Selecione o evento" (changeOption)="onEventChange($event)" />

        <sigecom-new-dropdown required="true" label="Competição da modalidade" class="bg-white rounded-lg"
          [options]="competitions?.content || []" [optionLabel]="'comTxNome'" [optionIdentify]="'comNrId'"
          [lastValidSelectedOption]="selectedCompetition || null" [disabled]="!selectedEvent?.eveNrId"
          placeholder="Selecione a competição" (changeOption)="onCompetitionChange($event)" />
      </div>
      <p *ngIf="!hasContextoCompleto" class="text-center text-sigecom-gray text-lg bg-white rounded-lg shadow-lg py-10">
        Selecione o Evento e a Modalidade
      </p>
      <sigecom-key-grid [petNrIds]="selectedPetNrIds" *ngIf="hasContextoCompleto"></sigecom-key-grid>
      <div class="w-full flex justify-end gap-2">
        <sigecom-button type="info" outlined title="ADICIONAR LOCAL" icon="plus" (buttonClicked)="openModalAddLocal()"
          *ngIf="hasContextoCompleto"></sigecom-button>
         <sigecom-button
          type="info"
          outlined
          title="MONTAR PRÉ-TABELA"
          icon="table"
          (buttonClicked)="montarPreTabela()"
        ></sigecom-button> 
      </div>
    </div>
  </div>
  <div after-content class="w-full pt-2 flex gap-4" *ngIf="hasContextoCompleto">
    <sigecom-content-container [topGap]="0" [bottomGap]="0"
      [ngClass]="{ 'flex-1': !minimize.value, 'w-fit': minimize.value }"
      class="h-[70vh] min-h-0 overflow-y-auto" [hasPadding]="false">
      <div content class="rounded-lg pr-2">
        <ng-container *ngIf="rodadaDtoList.length > 0; else semRodadas">
          <div class="items-center flex justify-between">
            <div class="flex gap-2 items-center mb-1">
              <h2 class="font-bold text-sigecom-info ml-2 text-lg text-nowrap">
                Rodada {{ rodadaCurrentIndex.value + 1 }} de
                {{ rodadaDtoList.length }}
              </h2>
              <div class="flex text-sigecom-info/50 gap-0.5">
                <fa-icon icon="chevron-left" (click)="changeRodadasPage('prev')" [ngClass]="{
                    'text-sigecom-gray/30': rodadaCurrentIndex.value == 0,
                    'hover:text-sigecom-info': rodadaCurrentIndex.value != 0,
                  }"></fa-icon>
                <fa-icon icon="chevron-right" (click)="changeRodadasPage('next')" [ngClass]="{
                    'text-sigecom-gray/30':
                      rodadaCurrentIndex.value + 1 == rodadaDtoList.length,
                    'hover:text-sigecom-info':
                      rodadaCurrentIndex.value + 1 != rodadaDtoList.length,
                  }"></fa-icon>
              </div>
            </div>
            <div *ngIf="!(minimize | async)"
              class="flex aspect-square h-full bg-gray-100 hover:bg-gray-200 rounded-full px-2"
              (click)="toggleMinimize()">
              <fa-icon class="text-md text-sigecom-info place-content-center" icon="minus"></fa-icon>
            </div>
          </div>

          <ng-container *ngIf="!(minimize | async); else maxmize">
            <div class="flex w-full gap-2 mt-2 mb-3 px-2 justify-center">
              <div *ngFor="let item of filters"
                class="px-4 flex gap-2 py-2 rounded-md border border-sigecom-gray text-sigecom-info bg-white hover:bg-slate-50 text-nowrap">
                <sigecom-radio-button name="sexoRodada" (selectedChange)="onSexFilterChange(item.value)"
                  [value]="item.value" [selected]="selectedFilter.value.value" [label]="item.key" />
              </div>
            </div>
            <!-- Table Header -->
            <ng-container *ngIf="confrontos?.length; else semConfrontos">
              <div
                class="grid-cols-[repeat(14,minmax(0,1fr))] text-lg mb-2 text-sigecom-gray grid gap-1 items-center mt-2 text-center">
                <div class="col-span-1"></div>
                <div class="col-span-2">Mod.</div>
                <div class="col-span-5">Equipe A</div>
                <div class="col-span-1"></div>
                <div class="col-span-5">Equipe B</div>
              </div>

              <div>
                <ng-container *ngFor="let item of confrontos; let i = index">
                  <div class="mb-1 grid-cols-[repeat(14,minmax(0,1fr))] gap-1 grid items-center text-center">
                    <div
                      class="col-span-1 font-medium cursor-pointer place-content-center pl-2 text-sigecom-info text-2xl px-auto h-full"
                      (click)="selectedEmbate.next(item.embNrId)">
                      <sigecom-radio-button #embates [value]="item.embNrId" [selected]="selectedEmbate.value"
                        (selectedChange)="selectedEmbate.next(item.embNrId)" />
                    </div>
                    <div
                      class="col-span-2 flex flex-col place-content-center text-[1rem] text-sigecom-info text-center font-medium p-2 rounded-lg h-full bg-gray-100">
                      <span>{{ getModalityAcronymByClash(item) }}</span>
                    </div>
                    <div
                      class="col-span-5 text-sigecom-info flex items-center text-xl font-medium p-3 rounded-lg h-full bg-gray-100">
                      <p class="text-center h-full select-none rounded-full w-full">
                        {{ getIncName(item.embListInscricaoDto.at(0)) }}
                        <small class="block text-xs text-sigecom-gray font-normal">
                          {{ getParticipantKeyName(item.embListInscricaoDto.at(0), item.cheTxNome) }}
                        </small>
                      </p>
                    </div>
                    <div class="col-span-1 text-sigecom-gray">X</div>
                    <div
                      class="col-span-5 place-content-center h-full text-sigecom-info text-xl font-medium p-3 rounded-lg bg-gray-100">
                      <p class="text-center select-none rounded-full w-full">
                        {{ getIncName(item.embListInscricaoDto.at(1)) }}
                        <small class="block text-xs text-sigecom-gray font-normal">
                          {{ getParticipantKeyName(item.embListInscricaoDto.at(1), item.cheTxNome) }}
                        </small>
                      </p>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
          <ng-template #maxmize>
            <div class="w-full place-content-center py-2">
              <sigecom-button type="info" title="VER CONFRONTOS NÃO AGENDADOS" (buttonClicked)="toggleMinimize()" />
            </div>
          </ng-template>
        </ng-container>

        <ng-template #semRodadas>
          <div class="flex justify-between items-center ml-2 text-lg text-nowrap">
            <b class="text-sigecom-danger">
              Parametrização sem rodadas cadastradas
            </b>
            <sigecom-button title="Editar parametrização" type="info" (buttonClicked)="navigateToEdit()"
              icon="shuffle" />
          </div>
        </ng-template>
        <ng-template #semConfrontos>
          <div class="flex justify-between mt-3 items-center ml-2 text-lg text-nowrap">
            <b class="text-sigecom-danger">
              Rodada sem confrontos cadastrados
            </b>
          </div>
        </ng-template>
      </div>
    </sigecom-content-container>

    <div class="rounded-lg pr-2 h-[70vh] min-h-0 overflow-y-auto"
      [ngClass]="{ 'w-full': minimize.value, 'flex-1': !minimize.value }">
      <sigecom-content-container [topGap]="0" [bottomGap]="0" [hasPadding]="false" [contentDirection]="'column'">
        <div content *ngFor="let item of confrontosComHora?.content">
          <div class="flex gap-3 flex-col">
            <div class="w-full flex justify-between items-center">
              <div class="flex gap-3 pl-2 text-sigecom-info items-center">
                <span class="text-xl font-semibold">
                  {{ item.areTxNome }}
                </span>
                <fa-icon icon="pen" class="cursor-pointer" (click)="editLocal(item)"></fa-icon>
              </div>
              <!-- <div
                class="px-4 flex gap-2 py-2 w-fit rounded-md border border-sigecom-gray text-sigecom-info bg-white text-nowrap"
              >
                <sigecom-radio-button
                  name="local"
                  (selectedChange)="selectedLocal.next(item.eprNrId)"
                  [selected]="selectedLocal != null"
                  label="Selecionar local"
                />
              </div> -->
            </div>
            <div
              class="rounded-lg text-lg p-4 place-content-center text-center text-sigecom-info font-semibold bg-gray-100">
              {{ item.epcTxNome }}
            </div>
            <ng-container *ngFor="let vaga of item.eprListEspacoVaga; let i = index">
              <div class="mb-1 grid-cols-[repeat(15,minmax(0,1fr))] grid items-center">
                <div
                  class="col-span-1 h-full mx-1 py-1 rounded-lg place-content-center text-center bg-gray-100 text-sigecom-info font-semibold">
                  {{ vaga.epvNrOrdemVaga ?? "-" }}
                </div>
                <div
                  class="col-span-1 h-full mx-1 py-1 rounded-lg place-content-center text-center bg-gray-100 text-sigecom-info font-semibold hover:bg-gray-200 cursor-pointer"
                  (click)="openModalAddHour(vaga)">
                  <ng-container *ngIf="vaga.epvTmInicio; else timeButton">
                    {{ vaga.epvTmInicio | hourMask }}
                  </ng-container>
                  <ng-template #timeButton>
                    <fa-icon icon="clock"></fa-icon>
                  </ng-template>
                </div>

                <ng-container *ngIf="
                    vaga.embateDto?.embListInscricaoDto?.length;
                    else addEmbate
                  ">
                  <div
                    class="col-span-1 h-full mx-1 py-1 flex flex-col rounded-lg p-2 text-sigecom-info text-center bg-gray-100 place-content-center text-[1rem]">
                    <span>{{ getModalityAcronymByVaga(vaga) }}</span>
                  </div>
                  <div
                    class="col-span-5 h-full mx-1 py-1 flex flex-col rounded-lg p-2 text-sigecom-info bg-gray-100 place-content-center pl-3 font-medium text-base">
                    <p>
                      {{ getIncName(getEmbateInscricao(vaga, 0)) }}
                      <small class="block text-xs text-sigecom-gray font-normal">
                        {{ getParticipantKeyName(getEmbateInscricao(vaga, 0), vaga.embateDto?.cheTxNome) }}
                      </small>
                    </p>
                  </div>
                  <div
                    class="col-span-1 h-full mx-1 py-1 font-normal place-content-center text-center text-sigecom-gray">
                    X
                  </div>
                  <div
                    class="col-span-5 h-full mx-1 py-1 flex flex-col rounded-lg p-2 text-sigecom-info bg-gray-100 place-content-center pl-3 font-medium text-base">
                    <p>
                      {{ getIncName(getEmbateInscricao(vaga, 1)) }}
                      <small class="block text-xs text-sigecom-gray font-normal">
                        {{ getParticipantKeyName(getEmbateInscricao(vaga, 1), vaga.embateDto?.cheTxNome) }}
                      </small>
                    </p>
                  </div>
                  <div
                    class="col-span-1 h-full mx-1 flex items-center justify-center text-sigecom-danger cursor-pointer hover:text-red-700"
                    title="Desvincular confronto" (click)="removerEmbateDaVaga(vaga)">
                    <fa-icon icon="trash"></fa-icon>
                  </div>
                </ng-container>
                <ng-template #addEmbate>
                  <div class="col-span-5 w-full py-2 ml-1 bg-gray-100 h-full rounded-l-lg"></div>
                  <div class="col-span-1 w-full py-2 bg-gray-100 cursor-pointer flex place-content-center h-full"
                    (click)="adicionarEmbateEmVaga(vaga.epvNrId)">
                    <div class="h-full justify-center items-center flex text-sigecom-info">
                      <fa-icon icon="plus"></fa-icon>
                    </div>
                  </div>
                  <div class="col-span-6 w-full py-2 mr-1 bg-gray-100 h-full"></div>
                  <div
                    class="cursor-pointer col-span-1 ml-2 w-auto py-2 bg-gray-100 rounded-lg flex place-content-center h-full text-sigecom-danger"
                    (click)="removerVaga(vaga)">
                    <fa-icon icon="trash" class="block"></fa-icon>
                  </div>
                </ng-template>
              </div>
            </ng-container>
            <sigecom-button class="w-full" (buttonClicked)="adicionarVaga(item.eprNrId)" title="Adicionar vaga"
              type="info" icon="plus"></sigecom-button>
          </div>
        </div>
      </sigecom-content-container>
    </div>
  </div>
</sigecom-content-container>
<sigecom-modal [open]="(modalAddArena | async) ?? false" (modalStateChange)="closeModalAddLocal()">
  <div modalContent class="w-[60rem]" *ngIf="(modalAddArena | async) ?? false">
    <form [formGroup]="modalAddArenaForm" class="flex flex-col mb-5 gap-2">
      <p class="text-lg font-semibold mb-2 text-sigecom-info text-nowrap">
        Adicionar local
      </p>
      <sigecom-new-dropdown formControlName="areNrId" label="Local de competição" [options]="arenasList?.content || []"
        optionIdentify="areNrId" optionLabel="areTxNome" />
      <sigecom-new-dropdown formControlName="epcNrId" label="Espaço" [options]="espacoList?.content || []"
        optionIdentify="epcNrId" optionLabel="epcTxNome" />
      <div class="grid grid-cols-2 gap-2">
        <sigecom-date-time-picker label="Horário inicial do espaço" [type]="DateTimeEnum.TIME"
          formControlName="eprTmHorarioInicial" />
        <sigecom-input-container label="Quantidade de inscrições" formControlName="eprNrQuantidadeInscricoes">
          <input sigecom-input type="number" min="0" placeholder="Digite..." formControlName="eprNrQuantidadeInscricoes"
            name="eprNrQuantidadeInscricoes" />
        </sigecom-input-container>
      </div>
      <div class="flex items-center justify-between mt-3 mb-4 gap-2 px-2">
        <label class="flex items-center gap-2 text-sigecom-info cursor-pointer">
          <input type="checkbox" formControlName="eprBlQuadraPrioritaria" name="eprBlQuadraPrioritaria" />
          <span>Quadra prioritária</span>
        </label>
        <label class="flex items-center gap-2 text-sigecom-info cursor-pointer">
          <sigecom-switch (switchStateChange)="
              modalAddArenaForm.get('eprBlTodasAsRodadas')?.setValue($event)
            "></sigecom-switch>
          <span>Adicionar a todas as rodadas</span>
        </label>
      </div>
      <div class="w-full flex gap-2 justify-end">
        <sigecom-button title="Deletar" outlined type="danger" icon="trash" (buttonClicked)="deleteSpace()"
          *ngIf="modalAddArenaForm.controls.entNrId.value" />
        <sigecom-button title="Salvar" outlined type="info" icon="save" (buttonClicked)="saveSpaceInRound()"
          [disabled]="modalAddArenaForm.invalid" />
      </div>
    </form>
  </div>
</sigecom-modal>

<sigecom-modal [open]="(embModalAddHour | async) != null" (modalStateChange)="closeModalAddHour()">
  <div *ngIf="embModalAddHour as emb" modalContent class="w-[60rem] h-fit pb-4">
    <form [formGroup]="modalAddHourForm" class="flex flex-col mb-5 gap-2">
      <p class="text-lg font-semibold mb-2 text-sigecom-info text-nowrap">
        Adicionar data e hora do embate
      </p>
      <div class="mb-1 grid-cols-[repeat(13,minmax(0,1fr))] px-10 pt-3 pb-6 gap-1 grid items-center text-center"
        *ngIf="emb.value?.list">
        <div class="col-span-6 text-sigecom-info flex items-center text-xl font-medium p-3 rounded-lg bg-gray-100">
          <p class="text-center h-full select-none rounded-full w-full">
            {{ getIncName(getEmbateInscricaoByModal(emb, 0)) }}
          </p>
        </div>
        <div class="col-span-1">X</div>
        <div
          class="col-span-6 flex place-content-center text-sigecom-info text-xl font-medium p-3 rounded-lg bg-gray-100">
          <p class="text-center h-full select-none rounded-full w-full">
            {{ getIncName(getEmbateInscricaoByModal(emb, 1)) }}
          </p>
        </div>
      </div>
      <sigecom-date-time-picker [type]="DateTimeEnum.TIME" formControlName="embDtDataHoraEmbate"
        label="Data e hora do embate" />
      <div class="w-full flex justify-end">
        <sigecom-button title="Salvar" outlined type="info" icon="save" [disabled]="modalAddHourForm.invalid"
          (buttonClicked)="updateClash(emb.value?.id, true)" />
      </div>
    </form>
  </div>
</sigecom-modal>
